var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row app-wrapper"},[_c('sidebar',{class:_vm.sidebarClassName,attrs:{"route":_vm.currentRoute}}),_c('section',{staticClass:"app-content columns",class:_vm.contentClassName},[_c('router-view'),_c('command-bar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }